/**
 * Shared calendar types for API contracts
 */
import { z } from "zod";
import { uuidSchema } from "./validation-common.js";
// ===== ENUMS =====
export const CalendarScopeSchema = z.enum(["USER", "USERS", "LOCATION"]);
// ===== INPUT SCHEMAS =====
/**
 * Schema for creating a calendar token
 * userId and companyId come from JWT, not request body
 */
export const CreateCalendarTokenInputSchema = z.object({
    scope: CalendarScopeSchema,
    scopeIds: z.array(uuidSchema).min(1),
    name: z.string().trim().min(1).max(100).optional(),
});
/**
 * Schema for calendar token ID param
 */
export const CalendarTokenIdParamSchema = z.object({
    id: uuidSchema,
});
/**
 * Schema for calendar feed token param (from URL)
 */
export const CalendarTokenParamSchema = z.object({
    token: z.string().min(1),
});
// ===== RESPONSE SCHEMAS =====
/**
 * Zod schema for calendar token API response
 * Used by oRPC contracts
 */
export const CalendarTokenResponseSchema = z.object({
    id: uuidSchema,
    userId: uuidSchema,
    companyId: uuidSchema,
    scope: CalendarScopeSchema,
    scopeIds: z.array(uuidSchema),
    token: z.string(),
    name: z.string().optional(),
    url: z.string(),
    createdAt: z.iso.datetime(),
});
